import { Accordion, Menu } from '@material-ui/core'
import styled from 'styled-components'
import { hFlex, vFlex } from '../../../../../../../../../Styles/style-helpers'
import { S05, Text } from '../../../../../../../../../Styles/typography'
import { darkAccent } from '../../../../../../../../../Styles/colors'

export const ParticipantsEl = styled.div`
  ${vFlex};
  width: 35%;
  height: 100%;
  justify-content: flex-start;
  padding: 1.5em 0 0;
  background: #f0f0f0;

  > h4 {
    width: 100%;
    text-align: center;
    margin-bottom: 1em;
  }

  .tabs {
    width: 100%;
    margin-bottom: 1em;
    padding: 0 0.5em;

    .MuiTab-root {
      width: 50%;
      min-width: 50%;
      max-width: 50%;
    }

    .PrivateTabIndicator-root-1 {
      background: #232323;
    }
  }

  .tabPanel {
    width: 100%;
    height: 100%;
    ${vFlex};
    justify-content: flex-start;
    overflow: auto;
    border: 0;
    padding: 0 0.5em;
  }
`

export const RegisteredTabEl = styled.div`
  ${hFlex};
  position: relative;
  width: 100%;
  justify-content: flex-start;
  padding: 1em 0;
  border-bottom: 1px solid #c7c7c7;

  .info {
    ${hFlex};
    justify-content: flex-start;
    width: 100%;

    .avatar {
      margin-right: 0.5em;
    }

    .info-details {
      padding-left: 1em;

      > p {
        width: 100%;
      }

      .error {
        ${hFlex};
        color: ${darkAccent};
        margin-top: 0.25em;

        > svg {
          font-size: 1em;
          margin-right: 0.25em;
          transform: translate(0, 5%);
        }
      }
    }
  }

  button {
    padding: 0;
    margin: 0.15em;
  }
`

export const MenuEl = styled(Menu)`
  .MuiMenuItem-root > button {
    border: 0;
    width: 100%;
    padding: 0;
    margin: 0;
    color: black;
  }
`

export const RequestTabEl = styled(Accordion)`
  margin: 1em 0 !important;
  border: 0;
  box-shadow: none !important;

  .MuiAccordionSummary-root {
    box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.5);
    border-radius: 0.5em;
    margin-bottom: 0.25em;
  }

  .MuiAccordionSummary-content {
    ${hFlex};
    margin: 0;
    justify-content: flex-start;

    > p {
      width: 100%;
      padding-left: 0.5em;
    }
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }

  .MuiAccordionSummary-root {
    transition: none;
    padding: 0.5em;
  }

  .MuiAccordionSummary-root.Mui-expanded {
    min-height: inherit;
    padding: 0.5em;
  }

  .MuiCollapse-container {
    margin-top: 0.25em;
  }

  .MuiAccordionDetails-root {
    ${vFlex};
    margin-top: 0.5em;
    box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.5);
    border-radius: 0.5em;
    align-items: flex-start;

    .audition-video {
      width: 100%;
      height: 100%;
      margin: 0.25em 0;
    }

    ${Text} {
      ${hFlex};
      font-weight: bold;
      width: 100%;
      justify-content: space-between;
      margin: 0.25em 0;

      button {
        transform: scale(0.85);
      }
    }

    ${S05} {
      margin-bottom: 1em;
    }

    .buttons {
      ${hFlex};
      width: 100%;
      justify-content: center;

      button {
        width: 7.5em;
        transform: scale(0.85);
      }
    }
  }
`
